import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import ConfigContext from '../../../contexts/ConfigContext';
import PublicEventsContext from './PublicEventsContext';
import { getCityTimezone } from '../../../modules/cityTimezone';

dayjs.extend(utc);
dayjs.extend(timezone);

function EventMeta({ event, location }) {
  const { locationId, truckId, image, description: contextDescription } = useContext(PublicEventsContext);
  const { url: contextUrl, vehicle_type } = useContext(ConfigContext);
  const url = `${contextUrl}#${event.id}`;

  let description = null;
  let name = null;
  let locationName = null;
  let address = null;

  if (location) {
    locationName = location.name ? location.name : location.filtered_address;
    address = location.address;
  }

  if (event.address) {
    address = event.address;
  }

  // Truck Events
  if (truckId) {
    name = event.display_name;
  }

  // Location Events
  if (locationId) {
    description = `Food ${vehicle_type}s at ${locationName}`;

    if (event.bookings && event.bookings.length > 0) {
      const truckNames = event.bookings.map((booking) => booking.truck.name);
      name = truckNames.join(', ');
    } else {
      name = `${locationName} Food ${vehicle_type}s`;
    }
  }

  const metaJSON = {
    '@context': 'http://schema.org',
    '@type': 'FoodEvent',
    name,
    description: description || contextDescription,
    startDate: dayjs(event.start_time).tz(getCityTimezone()).format(),
    endDate: dayjs(event.end_time).tz(getCityTimezone()).format(),
    url,
    eventAttendanceMode: 'https://schema.org/OfflineEventAttendanceMode',
    eventStatus: 'https://schema.org/EventScheduled',
    image,
    location: {
      '@type': 'Place',
      name: locationName,
      address,
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(metaJSON)}
      </script>
    </Helmet>
  );
}

EventMeta.propTypes = {
  event: PropTypes.object.isRequired,
};

export default EventMeta;
